import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";

import Posts from "components/Posts/Posts";
import PostForm from "components/Posts/PostForm";

class PostsView extends Component {
  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <div className="card">
            <div className="header">
              <h4 className="title">Posts</h4>
              <p className="category">
                Posts description text
              </p>
            </div>
            <div className="content">
              <Row>
                <Col md={12}>
                  <PostForm />
                  <Posts />
                </Col>
              </Row>
            </div>
          </div>
        </Grid>
      </div>
    );
  }
}

export default PostsView;



// WEBPACK FOOTER //
// ./src/views/Posts/PostsView.jsx